// extracted by css-extract-rspack-plugin
export default {"favorIconBtn":"favorIconBtn-ZYmfj1","selected":"selected-Cyc5Rw","favorMenuItem":"favorMenuItem-_UJO2B"};